namespace Matrix.Workflow {
    export interface ClientFunctionInvocationForm {
        FunctionName: FormatLookupEditor;
        Parameters: Serenity.StringEditor;
        StatusCode: FormatLookupEditor;
        StartedWhen: Serenity.DateTimeEditor;
        FinishedWhen: Serenity.DateTimeEditor;
        DurationMs: Serenity.StringEditor;
        StdOut: Serenity.TextAreaEditor;
        StdErr: Serenity.TextAreaEditor;
        WorkflowInstanceId: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ClientFunctionInvocationForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ClientFunctionInvocation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFunctionInvocationForm.init)  {
                ClientFunctionInvocationForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateTimeEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.IntegerEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(ClientFunctionInvocationForm, [
                    'FunctionName', w0,
                    'Parameters', w1,
                    'StatusCode', w0,
                    'StartedWhen', w2,
                    'FinishedWhen', w2,
                    'DurationMs', w1,
                    'StdOut', w3,
                    'StdErr', w3,
                    'WorkflowInstanceId', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
